// import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import yet from '../../../yet2-vue/src/yet/s/default.js'
Vue.use(Vuex)
const ui= {
  state: {
    modSelectorLoaded: false,
    showLogin: {t: false, non: Math.random()},
    unreadMsg: null,
  },
  mutations: {
    loadModSelector(state, value){
      state.modSelectorLoaded = value
    },
    setShowLogin(state, value){
      state.showLogin = {t: value, non: Math.random()}
    },
    setUnreadMsg(state,value){
      state.unreadMsg = value
    }
  },
  actions: {
  },
}
import login from '../../../yet2-vue/src/yet/s/login.js'
export default new Vuex.Store({
  modules: {
    ui: ui,
    login: login,
    yet: yet
  }
})
